/* ============================================================
   cart-bundle.js
   ------------------------------------------------------------
   Handles "remove" clicks inside the grouped cart-bundle block.
   Calls /cart/change.js with line key & quantity 0, then re-renders
   the cart drawer (and cart-icon-bubble) sections, mirroring what
   theme cart-items.js does.
   ============================================================ */

(function () {
  'use strict';

  function getRoutes() {
    return (window.routes && window.routes.cart_change_url)
      ? window.routes.cart_change_url
      : (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js');
  }

  function sectionsToRender() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map((s) => s.id).join(',');
    }
    // Fallback for cart page
    return 'main-cart-items,main-cart-footer,cart-icon-bubble,cart-drawer';
  }

  function applySections(data) {
    if (!data || !data.sections) return;

    // 1) If cart-drawer is mounted, let it handle the refresh (also opens drawer if closed)
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections['cart-drawer']) {
      drawer.renderContents(data);
      return;
    }

    // 2) Otherwise, manually swap sections on the cart page
    const swapMap = [
      { id: 'main-cart-items', selector: '.js-contents' },
      { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
      { id: 'cart-live-region-text', selector: '.cart-live-region-text' },
      { id: 'main-cart-footer', selector: '.js-contents-footer' },
    ];

    swapMap.forEach(({ id, selector }) => {
      const sectionHtml = data.sections[id];
      if (!sectionHtml) return;
      const target = document.querySelector(selector);
      if (!target) return;
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const fresh = parsed.querySelector(selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  async function changeLineQuantity(lineKey, newQty, sourceButton) {
    if (!lineKey) return;
    if (sourceButton) sourceButton.setAttribute('disabled', 'true');

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: newQty,
          sections: sectionsToRender(),
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('Cart change failed: ' + res.status);
      const data = await res.json();
      applySections(data);
    } catch (e) {
      console.error('[cart-bundle] quantity change failed', e);
      if (sourceButton) sourceButton.removeAttribute('disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const removeBtn = event.target.closest('[data-cart-bundle-remove]');
    if (removeBtn) {
      event.preventDefault();
      changeLineQuantity(removeBtn.getAttribute('data-line-key'), 0, removeBtn);
      return;
    }

    const qtyBtn = event.target.closest('[data-cart-bundle-qty-change]');
    if (qtyBtn) {
      event.preventDefault();
      const current = parseInt(qtyBtn.getAttribute('data-current'), 10) || 0;
      const direction = qtyBtn.getAttribute('data-direction');
      const next = direction === 'inc' ? current + 1 : Math.max(0, current - 1);
      changeLineQuantity(qtyBtn.getAttribute('data-line-key'), next, qtyBtn);
    }
  });
})();
